<template>
  <router-link
    :to="getJumpWikiDetailUrl(item.game_alias || item.game.alias, item.game_id || item.game.id, item.id, true)"
  >
    <div class="hot-question-item">
      <img class="seq" :src="require(`@/assets/zs_imgs/hot-question-${seq}.png`)" />
      <div class="content">
        <div class="title">{{ item.title }}</div>
        <div class="footer">
          <div class="left">
            <img class="icon" v-lazy="handleImgSize(item.user.avatar, 'mini')" />
            <span class="nick">{{ item.user.username }}</span>
          </div>
          <div class="right">
            <div class="item">
              <!-- <img class="icon" :src="require('@/assets/zs_imgs/article-dianzan.png')" /> -->
              <i class="icon zsicon icon-dianzan3"></i>
              <span class="count">{{ formatCount(item.like_count) }}</span>
            </div>
            <div class="item">
              <!-- <img class="icon" :src="require('@/assets/zs_imgs/article-pinglun.png')" /> -->
              <i class="icon zsicon icon-pinglun2"></i>
              <span class="count">{{ formatCount(item.comment_count) }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </router-link>
</template>
<script>
import dayjs from "@/plugins/dayjs";
import { getJumpWikiDetailUrl } from "@/plugins/util";

export default {
  name: "HotQuestionItem",
  props: ["item", "seq"],
  data() {
    return {};
  },
  methods: {
    getJumpWikiDetailUrl,
    formatDuration(time) {
      time = Date.now() / 1000 - time;
      if (time < 60) return "刚刚";
      const duration = dayjs.duration(time, "seconds");
      if (time < 60 * 60) return `${duration.format("m分钟前")}`;
      if (time < 60 * 60 * 24) return `${duration.format("H小时前")}`;
      if (time < 60 * 60 * 24 * 7) return `${duration.format("D天前")}`;
      return `${dayjs(Date.now() - time * 1000).format("YYYY年M月D日")}`;
    },
    formatCount(count) {
      if (count > 100000000) {
        const num = count / 100000000;
        if (num == (count / 100000000).toFixed(1)) {
          return num + "亿";
        } else {
          return (count / 100000000).toFixed(1) + "亿+";
        }
      } else if (count >= 10000) {
        const num = count / 10000;
        if (num == (count / 10000).toFixed(1)) {
          return num + "W";
        } else {
          return (count / 10000).toFixed(1) + "W+";
        }
      } else if (count >= 1000) {
        const num = count / 1000;
        if (num == (count / 1000).toFixed(1)) {
          return num + "K";
        } else {
          return (count / 1000).toFixed(1) + "K+";
        }
      } else {
        return count;
      }
    }
  }
};
</script>
<style lang="less" scoped>
.hot-question-item {
  display: flex;
  align-items: flex-start;
  margin: 20px 24px;
  gap: 17px;
  cursor: default;
  .seq {
    width: 20px;
    height: 26px;
  }
  .content {
    width: 0;
    flex-grow: 1;
  }
  .title {
    color: var(--zs-qz-entry-text-color);
    font-size: 14px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 12px;
    color: var(--zs-qz-article-option-text-color);
    .left,
    .right {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    .left {
      gap: 5px;

      font-size: 12px;
      .icon {
        width: 18px;
        height: 18px;
        display: block;
        border-radius: 10px;
      }
      .nick {
        margin-right: 20px;
      }
    }
    .right {
      display: flex;
      align-items: center;
      gap: 28px;
      .item {
        display: flex;
        align-items: center;
        gap: 5px;
        .icon {
          display: block;
          font-size: 16px;
        }
        .count {
          font-size: 12px;
        }
      }
    }
  }
}
</style>
